export const ContactsPage = () => {
    return (
        <div className="pagecontent">
            <h1>Контакты</h1>
        </div>
    )
}